module.exports = __webpack_public_path__ + "img/app-phone-4.b7c3e1e.svg";